import React from 'react';
import styled, { css } from 'styled-components';
import { Typography } from '@/components/atoms';
import { IImageWithTextData } from '../IImageWithTextCmp';
import Image from 'next/image';

const Item = styled.div<IContainer>`
  padding-top: 32px;
  padding-bottom: 32px;

  ${props =>
    props.numberItems > 3 &&
    css`
      grid-column: span 2;
      &:nth-last-child(1):nth-child(odd) {
        grid-column: 2 / span 2;
      }
    `}

  ${props => props.theme.breakpoints.up('sm')} {
    grid-column: auto;
    &:nth-last-child(1):nth-child(odd) {
      grid-column: auto;
    }
  }
`;

const ImageContainer = styled.div`
  max-width: 96px;
  margin: auto;
  ${props => props.theme.breakpoints.up('md')} {
    max-width: 144px;
  }
`;

const ItemTitle = styled.div`
  text-align: center;
  width: 100%;
  max-width: 200px;
  margin: 4px auto;
`;

const ItemDescription = styled(Typography)`
  text-align: center;
`;

const CustomTypo = styled(Typography)``;

interface IContainer {
  numberItems: number;
}

interface IWhyMirtaItem extends IImageWithTextData {
  numberOfItems: number;
}

const WhyMirtaItem: React.FC<IWhyMirtaItem> = props => {
  const { id, media, headingText, description, numberOfItems } = props;

  return (
    <Item key={id} numberItems={numberOfItems}>
      {media &&
        media.fields.file &&
        media.fields.file.details &&
        media.fields.file.details.image && (
          <ImageContainer>
            <Image
              src={media.fields.file.url || ''}
              alt={''}
              width={media.fields.file.details.image.width}
              height={media.fields.file.details.image.height}
              unoptimized={true}
            />
          </ImageContainer>
        )}
      {headingText || description ? (
        <>
          {headingText && (
            <ItemTitle>
              <CustomTypo
                datatype="subtitle_2"
                className="smalltitle"
                dangerouslySetInnerHTML={{
                  __html: headingText,
                }}
              />
            </ItemTitle>
          )}

          {description && (
            <ItemDescription key={id} datatype="body_1">
              {description}
            </ItemDescription>
          )}
        </>
      ) : null}
    </Item>
  );
};

export default WhyMirtaItem;
